import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../store/store";
import {InvestmentProgramRestoreDto} from "../../Assets/models/InvestmentProgram";

export type RestoredProfileInfoState = {
    investmentProgramRestoreInfo: InvestmentProgramRestoreDto,
};

export const initialProfileInfoState: RestoredProfileInfoState = {
    investmentProgramRestoreInfo: {
        ipName: "",
        profileName: null,
        profileOwner: null,
        ipStatus: "",
        restoredProfileName: "",
        wdsGMUrl: ""
    }
}

const restoredProfileInfoStateSlice = createSlice({
    name: "restoredProfileInfo",
    initialState: initialProfileInfoState,
    reducers: {
        setRestoredProfileInfoState: (state, action: PayloadAction<InvestmentProgramRestoreDto>) => {
            state.investmentProgramRestoreInfo = action.payload;
        }
    }
});

export const {
    setRestoredProfileInfoState
} = restoredProfileInfoStateSlice.actions;

export const selectRestoredProfileInfoState = (state: RootState) => state.client.restoredProfileInfo.investmentProgramRestoreInfo;

export default restoredProfileInfoStateSlice.reducer;